// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/portable-electronic-devices.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/portable-electronic-devices/portable-electronic-devices.js';

mount([g0]);
